import { InitOptions } from 'i18next'

export const defaultNamespace = 'common' as const

export const supportedLngs = ['en'] as const

export const fallbackLng: InitOptions['fallbackLng'] = {
  // Example of a fallback language. Should always have 'en' as the final fallback.
  // 'de-CH': ['de', 'en'],
  'en-US': ['en'],
  'en-CA': ['en'],
  default: ['en-AU', 'en'],
}

// Any namespace not listed here will be sent to the client on every page request,
// to prevent UI issues caused by async loading of namespaces where we haven't set
// up the UI to handle that nicely.
export const lazyLoadableNamespaces = new Set([])

export const showI18nStringsPostProcessor = {
  type: 'postProcessor' as const,
  name: 'showI18nStrings',
  process: function(value) {
    return `｢${value}｣`
  },
}
